export const isOwnBrand = (state) => state.advisorOrg.isOwnBrand;

export const byobTradingName = (state) => state.advisorOrg.tradingName;

export const advisorOrgIds = (state) => state.advisorOrg.advisorOrgIds;

export const advisorOrg = (state) => state.advisorOrg;
